import { useState } from 'react';

import dayjs from 'dayjs';

import { useGetEligibleTokensQuery } from '@features/token-management/api/token-management.api';
import type { RTKQueryError } from '@shared/utils/api.types';

export const useGetAvailableTokens = () => {
  const [lastUpdated, setLastUpdated] = useState(dayjs().format('MMM D, YYYY HH:mm'));

  const { data, isLoading, isFetching, isError, error, refetch } = useGetEligibleTokensQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const availableTokens = data?.totalEligibleTokens ?? null;
  const isLoadingTokens = isLoading || isFetching;
  const errorMessage = isError ? ((error as RTKQueryError)?.data?.message ?? null) : null;

  const handleRefresh = async () => {
    try {
      await refetch().unwrap();
      setLastUpdated(dayjs().format('MMM D, YYYY HH:mm'));
    } catch (refreshError) {
      console.error('Failed to refresh tokens', refreshError);
    }
  };

  return {
    availableTokens,
    lastUpdated,
    handleRefresh,
    isLoadingTokens,
    isError,
    errorMessage,
  };
};
